<template>
<div class="block-img" :class="{empty: !media}">
  <div class="img-empty" v-if="!media.length">
    (not selected)
  </div>
  <div class="img-gallery" v-else>
    <div v-for="(item, ii) in media">
      <a :href="item.urlFilename" target="_blank"><img :src="item.urlFilename" alt="" :class="{video: oembed}" /></a>
      <div>
        <label>Name:</label> <span>{{ item.filename }}</span><br />
        <template v-if="false">
        <label>Author:</label> <span>{{ oembed.author_name }}</span><br />
        <label>Provider:</label> <span>{{ oembed.provider_name }}</span><br />
        </template>
        <template v-if="item.width">
        <label>Dimensions:</label> <span>{{ item.width }}x{{ item.height }}</span><br />
        </template>
        <template v-if="item.size">
        <label>File size:</label> <span>{{ formatFileSize(item.size) }}</span><br />
        <label>File type:</label> <span>{{ formatFileType(item.filename) }}</span><br />
        </template>
        <button class="btn btn-large" v-on:click.prevent="removeItem(ii)">Remove</button>
      </div>
    </div>
    <div class="empty">
      <button class="btn btn-large" v-on:click.prevent="select">Add</button>      
    </div>
  </div>
  <button class="btn btn-large" v-if="!media.length" v-on:click.prevent="select">Add</button>
</div>
</template>

<script>
import api from '@/Util/api';
export default {
  props: ["modelValue"],
  data: ()=>({
    media: [],
  }),
  watch: {
    modelValue: {
      immediate: true,
      async handler() {
        var ids=(this.modelValue || "").split(",").filter((a)=>a);
        var mediaGet=[];
        for(var i of ids)
          mediaGet.push(api.get("File", i));
        var media=[];
        for(var i of mediaGet)
          media.push((await i));
        this.media=media;
      },
    },
  },
  computed: {
    oembed() {
      var result=[];
      for(var i in this.media) {
        try {
          result.push(JSON.parse(this.media[i].oembed));
        } catch(e) {
          result.push(null);
        }
      }
      return result;
    },
  },
  methods: {
    createLink(type) {
      return {
        name: "page",
        params: {
          path: [...this.$route.params.path, type],
        }
      }
    },
    select() {
      this.stores.callbacks.pushCallback((...args)=>this.doSelect(...args));
      this.$router.push(this.createLink('File'));
    },
    doSelect(item) {
      var currentItems=(this.modelValue || "").split(",").filter((a)=>a);
      currentItems.push(item.uuid);
      this.$emit("update:modelValue", currentItems.join(","));
    },

    removeItem(ii) {
      var currentItems=(this.modelValue || "").split(",").filter((a)=>a);
      currentItems.splice(ii, 1);
      this.$emit("update:modelValue", currentItems.join(","));
    },
    formatFileType(path) {
      var res=path && path.match(/\.([^.\/]+)$/);
      return res?res[1]:"unknown";
    },
    formatFileSize(size) {
      size*=1;
      if (!size)
        return "(unknown)";
      if (size<1024)
        return size+" B";
      size/=1024;
      if (size<1024)
        return size.toFixed(2)+" kB";
      size/=1024;
      if (size<1024)
        return size.toFixed(2)+" MB";
      size/=1024;
      return size.toFixed(2)+" GB";
    },
  },
}
</script>
